import type { Translations } from '../../types'

const builderMessages: Translations = {
  "builder.title": "Page Builder",
  "builder.heading": "Page Builder",
  "builder.description": "Modifica le sezioni pagina con anteprima storefront live.",
  "builder.select": "Seleziona pagina",
  "builder.save": "Salva",
  "builder.savePage": "Salva",
  "builder.saveDraft": "Salva bozza",
  "builder.more": "Pagina",
  "builder.loading": "Caricamento pagina...",
  "builder.saveState.ready": "Salvato",
  "builder.saveState.saving": "Salvataggio...",
  "builder.page.label": "Pagina",
  "builder.editor.label": "Page builder",
  "builder.page.title": "Titolo pagina",
  "builder.page.slug": "Slug pagina",
  "builder.page.rename": "Rinomina",
  "builder.page.actions": "Pagina",
  "builder.page.panelUnavailable": "Questo pannello pagina non e disponibile.",
  "builder.tabs.content": "Contenuto",
  "builder.tabs.seo": "SEO",
  "builder.tabs.translations": "Traduzioni",
  "builder.tabs.settings": "Pagina",
  "builder.status.draft": "Bozza",
  "builder.status.published": "Pubblicata",
  "builder.overview.title": "Contenuto",
  "builder.overview.selectBlock": "Seleziona un blocco dalla navigazione per iniziare a modificare.",
  "builder.overview.noBlocks": "Nessun blocco.",
  "builder.overview.addFirstBlock": "Aggiungi il primo blocco contenuto",
  "builder.blocks.label": "Sezioni",
  "builder.blocks.count": "{{count}} sezioni",
  "builder.blocks.add": "Aggiungi sezione",
  "builder.blocks.addShort": "Aggiungi",
  "builder.blocks.search": "Cerca sezioni...",
  "builder.blocks.availableCount": "{{count}} sezioni disponibili",
  "builder.blocks.oneAvailable": "1 sezione disponibile",
  "builder.blocks.description.content": "Testi, media e contenuti della pagina.",
  "builder.blocks.description.commerce": "Prodotti, prezzi e contenuti commerciali.",
  "builder.blocks.description.category": "Link categoria e navigazione catalogo.",
  "builder.blocks.description.collection": "Una sezione ripetibile con elementi modificabili.",
  "builder.blocks.description.media": "Contenuti visivi basati su immagini.",
  "builder.blocks.description.navigation": "Menu, link e navigazione pagina.",
  "builder.blocks.description.marketing": "Contenuti promozionali e di fiducia.",
  "builder.blocks.empty": "Aggiungi una sezione per iniziare questa pagina.",
  "builder.blocks.missing": "Seleziona una sezione per iniziare a modificare.",
  "builder.collections.label": "Collezioni",
  "builder.collections.addItem": "Aggiungi elemento",
  "builder.collections.empty": "Nessun elemento.",
  "builder.collections.itemCount": "{{count}} elementi",
  "builder.collections.missing": "Seleziona una collezione per modificarne gli elementi.",
  "builder.collections.navigationHint": "{{count}} collezione/i sono gestite dalle impostazioni sezione.",
  "builder.collections.workspaceHint": "Modifica i contenuti ripetibili direttamente in questo workspace sezione.",
  "builder.collections.value": "Valore",
  "builder.settings.empty": "Questa sezione non ha impostazioni.",
  "builder.settings.sectionSettings": "Impostazioni sezione",
  "builder.settings.group.content": "Contenuto",
  "builder.settings.group.contentDescription": "Testi principali, media e contenuti visibili al cliente.",
  "builder.settings.group.commerce": "Commerce",
  "builder.settings.group.commerceDescription": "Riferimenti a prodotti e categorie.",
  "builder.settings.group.display": "Aspetto",
  "builder.settings.group.displayDescription": "Opzioni di presentazione e visibilita.",
  "builder.settings.group.advanced": "Avanzate",
  "builder.settings.group.advancedDescription": "Link, ancore, classi e valori tecnici.",
  "builder.drawer.close": "Chiudi editor elemento",
  "builder.drawer.done": "Fine",
  "builder.sidebar.title": "Sezioni",
  "builder.sidebar.search": "Cerca sezioni...",
  "builder.sidebar.empty": "Nessuna sezione trovata.",
  "builder.sidebar.other": "Altro",
  "builder.sidebar.sections": "Sezioni",
  "builder.sections.title": "Sezioni pagina",
  "builder.sections.add": "Aggiungi sezione",
  "builder.sections.empty": "Nessuna sezione.",
  "builder.sections.select": "Seleziona una sezione dalla lista o cliccala nell'anteprima.",
  "builder.sections.back": "Sezioni",
  "builder.blockTree.title": "Struttura pagina",
  "builder.blockTree.addBlock": "Aggiungi blocco",
  "builder.blockTree.empty": "Nessun blocco",
  "builder.blockTree.emptyMainArea": "Area principale vuota",
  "builder.blockTypes.hero": "Hero",
  "builder.blockTypes.features": "Funzionalita",
  "builder.blockTypes.feature": "Funzionalita",
  "builder.blockTypes.collection-grid": "Griglia collezione",
  "builder.blockTypes.footer": "Footer",
  "builder.blockTypes.trust-badge": "Badge fiducia",
  "builder.blockTypes.trust-badges": "Badge fiducia",
  "builder.blockDrawer.title": "Blocchi disponibili",
  "builder.blockDrawer.description": "Blocchi core e blocchi forniti dai plugin attivi.",
  "builder.blockDrawer.loading": "Caricamento blocchi...",
  "builder.blockDrawer.empty": "Nessun blocco disponibile.",
  "builder.upload.loading": "Caricamento...",
  "builder.upload.action": "Carica",
  "builder.upload.progress": "Caricamento immagine...",
  "builder.media.choose": "Scegli",
  "builder.media.clear": "Svuota",
  "builder.media.empty": "Nessun media selezionato",
  "builder.media.loading": "Caricamento...",
  "builder.media.selectedId": "ID media",
  "builder.media.libraryDescription": "Scegli un'immagine per questo blocco.",
  "builder.media.loadError": "Errore nel caricamento della media library.",
  "builder.media.invalidId": "Seleziona un media valido.",
  "builder.media.uploadInvalid": "L'upload non ha restituito un record media.",
  "builder.media.uploadFailed": "Upload fallito.",
  "builder.media.legacyUrl": "Valore URL legacy rilevato. Scegli o carica un media per sostituirlo con un ID media.",
  "builder.category.choose": "Scegli",
  "builder.category.clear": "Svuota",
  "builder.category.clearOne": "Rimuovi categoria",
  "builder.category.empty": "Nessuna categoria selezionata",
  "builder.category.loading": "Caricamento...",
  "builder.category.selectedId": "ID categoria",
  "builder.category.selectedIds": "ID categorie",
  "builder.category.selectedTitle": "Categorie selezionate",
  "builder.category.dragHandle": "Trascina categoria",
  "builder.category.browserTitle": "Seleziona categoria",
  "builder.category.browserDescription": "Scegli le categorie per questo blocco.",
  "builder.category.searchPlaceholder": "Cerca per nome o slug...",
  "builder.category.search": "Cerca",
  "builder.category.resetSearch": "Reset",
  "builder.category.resultCount": "{{count}} categorie",
  "builder.category.multiSelected": "{{count}} selezionate",
  "builder.category.noResults": "Nessuna categoria trovata.",
  "builder.category.prev": "Precedente",
  "builder.category.next": "Successiva",
  "builder.category.done": "Fine",
  "builder.category.close": "Chiudi",
  "builder.category.loadError": "Errore nel caricamento categorie.",
  "builder.category.invalidId": "Seleziona una categoria valida.",
  "builder.category.invalidPersisted": "Uno o piu ID categoria salvati non sono piu risolvibili.",
  "builder.product.choose": "Scegli",
  "builder.product.clear": "Svuota",
  "builder.product.empty": "Nessun prodotto selezionato",
  "builder.product.loading": "Caricamento...",
  "builder.product.selectedId": "ID prodotto",
  "builder.product.selectedIds": "ID prodotti",
  "builder.product.browserTitle": "Seleziona prodotto",
  "builder.product.browserDescription": "Scegli i prodotti per questo blocco.",
  "builder.product.searchPlaceholder": "Cerca per nome, slug, brand, modello o codice...",
  "builder.product.search": "Cerca",
  "builder.product.resetSearch": "Reset",
  "builder.product.resultCount": "{{count}} prodotti",
  "builder.product.multiSelected": "{{count}} selezionati",
  "builder.product.noResults": "Nessun prodotto trovato.",
  "builder.product.prev": "Precedente",
  "builder.product.next": "Successiva",
  "builder.product.done": "Fine",
  "builder.product.close": "Chiudi",
  "builder.product.stock": "Stock {{count}}",
  "builder.product.loadError": "Errore nel caricamento prodotti.",
  "builder.product.invalidId": "Seleziona un prodotto valido.",
  "builder.product.invalidPersisted": "Uno o piu ID prodotto salvati non sono piu risolvibili.",
  "builder.faq.empty": "Aggiungi le domande frequenti con il pulsante qui sotto.",
  "builder.faq.remove": "Rimuovi",
  "builder.faq.question": "Domanda",
  "builder.faq.answer": "Risposta",
  "builder.faq.add": "+ Aggiungi domanda",
  "builder.field.selectPlaceholder": "Seleziona",
  "builder.field.invalidArray": "Il valore deve essere un array",
  "builder.field.jsonHint": "Inserisci un array JSON (es. [{\"title\":\"...\",\"href\":\"...\"}]).",
  "builder.field.widthExample": "es. 1fr, 320px, 40%",
  "builder.icon.searchPlaceholder": "Cerca icone...",
  "builder.icon.clear": "Svuota",
  "builder.icon.change": "Cambia",
  "builder.icon.close": "Chiudi selettore icone",
  "builder.icon.noResults": "Nessuna icona trovata.",
  "builder.icon.selected": "Icona selezionata",
  "builder.validation.required": "Questo campo e obbligatorio.",
  "builder.validation.number": "Inserisci un numero valido.",
  "builder.validation.minimum": "Deve essere almeno {{value}}.",
  "builder.validation.maximum": "Deve essere al massimo {{value}}.",
  "builder.validation.minLength": "Deve contenere almeno {{value}} caratteri.",
  "builder.validation.maxLength": "Deve contenere al massimo {{value}} caratteri.",
  "builder.validation.minItems": "Aggiungi almeno {{value}} elemento/i.",
  "builder.validation.maxItems": "Usa al massimo {{value}} elemento/i.",
  "builder.validation.pattern": "Il valore non rispetta il formato richiesto.",
  "builder.validation.validOption": "Seleziona un'opzione valida.",
  "builder.validation.validOptions": "Rimuovi le opzioni non supportate.",
  "builder.validation.mediaId": "Seleziona un media valido.",
  "builder.validation.iconId": "Seleziona un'icona valida.",
  "builder.validation.categoryId": "Seleziona categorie valide.",
  "builder.validation.productId": "Seleziona prodotti validi.",
  "builder.repeater.empty": "Nessun elemento. Aggiungi una riga.",
  "builder.repeater.addRow": "+ Aggiungi riga",
  "builder.repeater.removeRow": "Rimuovi",
  "builder.repeater.item": "Riga",
  "builder.repeater.moveUp": "Su",
  "builder.repeater.moveDown": "Giu",
  "builder.repeater.selected": "Elemento selezionato",
  "builder.repeater.editing": "Modifica",
  "builder.repeater.editBadge": "Modifica",
  "builder.repeater.closeEditor": "Chiudi editor",
  "builder.repeater.editingBadge": "Modifica badge",
  "builder.repeater.badgePosition": "Badge {{current}} di {{total}}",
  "builder.repeater.visual": "Visuale",
  "builder.repeater.content": "Contenuto",
  "builder.repeater.colorCustom": "Personalizzato",
  "builder.inspector.title": "Impostazioni sezione",
  "builder.inspector.empty": "Seleziona una sezione per modificarne le impostazioni.",
  "builder.actions.duplicate": "Duplica",
  "builder.actions.edit": "Modifica",
  "builder.actions.delete": "Elimina",
  "builder.actions.moveUp": "Sposta su",
  "builder.actions.moveDown": "Sposta giu",
  "builder.actions.more": "Altre azioni",
  "builder.actions.dragHandle": "Trascina sezione",
  "builder.canvas.content": "Contenuto sezione",
  "builder.canvas.emptyColumn": "Trascina un blocco contenuto in questa colonna",
  "builder.canvas.emptySection": "Trascina un blocco contenuto qui",
  "builder.canvas.emptyRoot": "Aggiungi un blocco contenuto per iniziare a comporre la pagina",
  "builder.canvas.endOfRoot": "Trascina un blocco contenuto qui per aggiungerlo",
  "builder.canvas.delete": "Elimina blocco contenuto",
  "builder.canvas.dropToDelete": "Rilascia qui per eliminare",
  "builder.preview.title": "Anteprima live",
  "builder.preview.action": "Anteprima",
  "builder.preview.live": "Live",
  "builder.preview.deviceControls": "Dispositivo anteprima",
  "builder.preview.desktop": "Desktop",
  "builder.preview.tablet": "Tablet",
  "builder.preview.mobile": "Mobile",
  "builder.preview.collapse": "Comprimi",
  "builder.preview.show": "Mostra anteprima",
  "builder.preview.hide": "Nascondi anteprima",
  "builder.preview.empty": "Nessuna anteprima.",
  "builder.more.pageSettings": "Impostazioni pagina",
  "builder.more.seo": "SEO",
  "builder.more.translations": "Traduzioni",
  "builder.more.publish": "Pubblica",
  "builder.more.backToPages": "Torna alle pagine",
  "builder.more.pages": "Pagine",
  "builder.tools.label": "Strumenti pagina",
  "builder.tools.duplicatePage": "Duplica pagina",
  "builder.pageFallback": "Pagina",
  "builder.renderer.missing": "Renderer mancante per {{type}}",
  "builder.toast.loginRequired": "Fai login per usare il Compositore contenuti.",
  "builder.toast.pageNotFound": "Pagina non trovata o API non raggiungibile",
  "builder.toast.loadError": "Errore nel caricamento della pagina per il compositore.",
  "builder.toast.loaded": "Pagina caricata nel compositore.",
  "builder.toast.loginToSave": "Fai login per salvare la pagina.",
  "builder.toast.pickPage": "Seleziona una pagina da modificare.",
  "builder.toast.invalidSlug": "Slug o ID pagina non valido per il salvataggio.",
  "builder.toast.saveFailed": "Salvataggio fallito ({{status}}): {{message}}",
  "builder.toast.saved": "Pagina salvata nel CMS.",
  "builder.toast.saveError": "Errore salvataggio pagina."
}

export default builderMessages
